import React from 'react';
import ProductCard from './ProductCard';

function ProductList({ products, groups, onEdit, onDelete }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {products.map(product => (
        <ProductCard
          key={product.id}
          product={product}
          groups={groups}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}

export default ProductList;